<template>
  <v-autocomplete
    filled
    :items="serviceProvidersItems"
    item-text="description"
    item-value="id"
    label="Service provider"
    :rules="rules"
    :hint="hint"
    :persistent-hint="showHint"
    v-model="selectValueItem"
    @change="$emit('change', selectValueItem)"
    clearable>
  </v-autocomplete>
</template>

<script>
export default {
  name: 'BaseInputSelectServiceProviders',
  props: {
    serviceProviders: {
      type: Array,
      require: true
    },
    selectedValue: {
      require: false
    },
    rules: {
      type: Array,
      require: false
    },
    hint: {
      type: String,
      require: false
    }
  },
  data () {
    return {
      selectValueItem: ''
    }
  },
  mounted () {
    this.selectValueItem = this.selectedValue
  },
  watch: {
    selectedValue (val) {
      this.selectValueItem = val
    }
  },
  computed: {
    showHint () {
      return !!this.hint
    },
    serviceProvidersItems () {
      const returnServiceProviders = []

      returnServiceProviders.push({ header: 'Active service providers' })
      this.serviceProviders.filter(serviceProviders => serviceProviders.active === true)
        .forEach(serviceProviders => returnServiceProviders.push(serviceProviders))

      returnServiceProviders.push({ header: 'Inactive service providers' })
      this.serviceProviders.filter(serviceProviders => serviceProviders.active === false)
        .forEach(serviceProviders => returnServiceProviders.push(serviceProviders))

      return returnServiceProviders
    }
  }
}
</script>

<style scoped>

</style>
